export default {
  bindings: {
    errors: '<'
  },
  template: require('../views/error.messages.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/error/components/error.messages.component.js